import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      padding: constants.divPadding,
      borderRadius: constants.radius.view,
      backgroundColor: theme.card.background,
    },
    inner: {
      flexWrap: "wrap",
      alignItems: "stretch",
    },
    title: {
      fontWeight: "bold",
    },
    spacing: {
      marginRight: spacing.m,
      marginTop: spacing.m,
    },
  };

  return styles;
};
